import { FBFormModel } from "./../../../models/formBuilderModels";
import { PagingResultsModel } from "./../../../models/pagingResultsModel";
import { UserModel } from "src/app/models/userModel";
import {
  OfferLetterModel,
  OfferLetterWithUserModel,
} from "./../../../models/offerLetterModel";
import { createReducer, on, Action } from "@ngrx/store";
import {
  loadOfferLetterDocSuccess,
  loadOfferLetterDoc,
  signOfferLetterDoc,
  signOfferLetterDocSuccess,
  updateCreateOfferletterForm,
  createOfferLetter,
  createOfferLetterSuccess,
  getOfferLettersList,
  getOfferLettersListSuccess,
  getOfferLetterPdf,
  getOfferLetterPdfSuccess,
  createOfferLetterFail,
  previewOfferLetter,
  previewOfferLetterSuccess,
  previewOfferLetterFail,
  getOfferLettersInfo,
  getOfferLettersInfoSuccess,
  saveOfferLetterSuccess,
  saveOfferLetterFail,
  saveOfferLetter,
  clearOfferletter,
  markOfferLetterSeenSuccess,
  markOfferLetterSeen,
  signOfferLetterDocFail,
  checkUsername,
  checkUsernameSuccess,
  getOfferletterAvailableFormsSuccess,
} from "./offerletter.actions";
import { UntypedFormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { FormError } from "src/app/models/utilModels";
import { deepClone } from "src/app/helpers/utils";

export interface OfferLetterState {
  loadingDoc: boolean;
  loadingSign: boolean;
  docArrayBuffer: ArrayBuffer;
  docSignedArrayBuffer: ArrayBuffer;
  offerletterWithUser: OfferLetterWithUserModel;
  creatingOfferletter: boolean;
  previewingOfferletter: boolean;
  docOfferLetterPreviewed: ArrayBuffer;
  docOfferLetterCreated: ArrayBuffer;
  formErrors: FormError[];
  usersList: UserModel[];
  loadingUsersList: boolean;
  offerLettersList: PagingResultsModel<OfferLetterWithUserModel>;
  loadingOfferLetterList: boolean;

  loadingOfferLetter: boolean;
  usernameTaken: boolean;

  availableForms: FBFormModel[];
}

const initialState: OfferLetterState = {
  loadingDoc: false,
  loadingSign: false,
  docArrayBuffer: null,
  docSignedArrayBuffer: null,
  offerletterWithUser: {
    user: {} as UserModel,
    offerLetter: {} as OfferLetterModel,
  },
  formErrors: [],
  creatingOfferletter: false,
  docOfferLetterCreated: null,
  previewingOfferletter: false,
  docOfferLetterPreviewed: null,
  loadingUsersList: false,
  usersList: null,
  offerLettersList: null,
  loadingOfferLetterList: false,
  loadingOfferLetter: false,
  usernameTaken: false,
  availableForms: null,
};

export const offerLetterReducer = createReducer(
  initialState,
  on(loadOfferLetterDoc, (state, action) => {
    return {
      ...state,
      loadingDoc: true,
    };
  }),
  on(loadOfferLetterDocSuccess, (state, action) => {
    return {
      ...state,
      docArrayBuffer: action.doc,
      loadingDoc: false,
    };
  }),
  on(signOfferLetterDoc, (state, action) => {
    return {
      ...state,
      loadingSign: true,
    };
  }),
  on(signOfferLetterDocSuccess, (state, action) => {
    return {
      ...state,
      docSignedArrayBuffer: action.docSigned,
      loadingSign: false,
    };
  }),
  on(signOfferLetterDocFail, (state, action) => {
    return {
      ...state,
      loadingSign: false,
    };
  }),
  on(updateCreateOfferletterForm, (state, action) => {
    const newUser = { ...state.offerletterWithUser.user, ...action.userValues };
    const newOfferLetter = {
      ...state.offerletterWithUser.offerLetter,
      ...action.offerValues,
    };
    const newOfferletterWithUser = {
      ...state.offerletterWithUser,
      ...{ user: newUser, offerLetter: newOfferLetter },
    };
    const newState = {
      ...state,
      ...{
        offerletterWithUser: newOfferletterWithUser,
        formErrors: action.formErrors,
      },
    };
    return newState;
  }),

  on(createOfferLetter, (state, action) => {
    return {
      ...state,
      creatingOfferletter: true,
    };
  }),
  on(createOfferLetterSuccess, (state, action) => {
    return {
      ...state,
      offerLetterCreated: action.doc,
      creatingOfferletter: false,
    };
  }),
  on(createOfferLetterFail, (state, action) => {
    return {
      ...state,
      offerLetterCreated: null,
      creatingOfferletter: false,
    };
  }),
  on(previewOfferLetter, (state, action) => {
    return {
      ...state,
      previewingOfferletter: true,
    };
  }),
  on(previewOfferLetterSuccess, (state, action) => {
    return {
      ...state,
      docOfferLetterPreviewed: action.doc,
      previewingOfferletter: false,
    };
  }),
  on(previewOfferLetterFail, (state, action) => {
    return {
      ...state,
      docOfferLetterPreviewed: null,
      previewingOfferletter: false,
    };
  }),
  on(getOfferLettersList, (state, action) => {
    return {
      ...state,
      loadingOfferLetterList: true,
    };
  }),
  on(getOfferLettersListSuccess, (state, action) => {
    return {
      ...state,
      offerLettersList: action.offerLetterList,
      loadingOfferLetterList: false,
    };
  }),

  on(getOfferLetterPdf, (state, action) => {
    return {
      ...state,
      loadingDoc: true,
    };
  }),
  on(getOfferLetterPdfSuccess, (state, action) => {
    return {
      ...state,
      docArrayBuffer: action.doc,
      loadingDoc: false,
    };
  }),
  on(getOfferLettersInfo, (state, action) => {
    return {
      ...state,
      loadingOfferLetter: true,
    };
  }),
  on(getOfferLettersInfoSuccess, (state, action) => {
    return {
      ...state,
      offerletterWithUser: action.offerLetter,
      loadingOfferLetter: false,
    };
  }),

  on(saveOfferLetter, (state, action) => {
    return {
      ...state,
      creatingOfferletter: true,
    };
  }),
  on(saveOfferLetterSuccess, (state, action) => {
    return {
      ...state,
      offerletterWithUser: action.offerletterWithUser,
      creatingOfferletter: false,
    };
  }),
  on(saveOfferLetterFail, (state, action) => {
    return {
      ...state,
      offerLetterCreated: null,
      creatingOfferletter: false,
    };
  }),

  on(clearOfferletter, (state, action) => {
    return {
      ...state,
      offerletterWithUser: {
        user: {} as UserModel,
        offerLetter: {
          prospectiveCandidateID: action.prospectiveCandidateID,
        } as OfferLetterModel,
      },
    };
  }),

  on(markOfferLetterSeen, (state, action) => {
    return {
      ...state,
      loadingOfferLetterList: true,
    };
  }),

  on(markOfferLetterSeenSuccess, (state, action) => {
    const offerLettersList: PagingResultsModel<OfferLetterWithUserModel> =
      deepClone(state.offerLettersList);
    const offerLetterIndex = offerLettersList.result.findIndex(
      (x) => x.offerLetter.id === action.offerLetter.offerLetter.id
    );
    if (offerLetterIndex >= 0) {
      offerLettersList.result[offerLetterIndex] = deepClone(action.offerLetter);
    }
    return {
      ...state,
      offerLettersList,
      loadingOfferLetterList: false,
    };
  }),
  on(checkUsernameSuccess, (state, action) => {
    return {
      ...state,
      usernameTaken: action.usernameTaken,
    };
  }),

  on(getOfferletterAvailableFormsSuccess, (state, action) => {
    return {
      ...state,
      availableForms: action.availableForms,
    };
  })
);

export function offerLetterReducerFunc(
  state: OfferLetterState | undefined,
  action: Action
) {
  return offerLetterReducer(state, action);
}

export function initCreateOfferletterForm(
  offerletterWithUser: OfferLetterWithUserModel
) {
  const form = new UntypedFormGroup({
    user: new UntypedFormGroup({
      id: new UntypedFormControl(offerletterWithUser.user.id, []),
      email: new UntypedFormControl(offerletterWithUser.user.email),
      personalEmail: new UntypedFormControl(offerletterWithUser.user.personalEmail, [
        Validators.required,
        Validators.maxLength(255),
        Validators.email,
      ]),
      username: new UntypedFormControl(offerletterWithUser.user.userName, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      password: new UntypedFormControl(offerletterWithUser.user.password, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      firstName: new UntypedFormControl(offerletterWithUser.user.firstName, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      lastName: new UntypedFormControl(offerletterWithUser.user.lastName, [
        Validators.required,
        Validators.maxLength(255),
      ]),
    }),
    offerLetter: new UntypedFormGroup({
      formID: new UntypedFormControl(offerletterWithUser.offerLetter.formID, []),
      prospectiveCandidate: new UntypedFormControl(
        !!offerletterWithUser.offerLetter.prospectiveCandidateID,
        []
      ),
      prospectiveCandidateID: new UntypedFormControl(
        offerletterWithUser.offerLetter.prospectiveCandidateID,
        []
      ),
      existingUser: new UntypedFormControl(
        !!offerletterWithUser.offerLetter.existingUser,
        []
      ),
      reportingToUserIDs: new UntypedFormControl(
        offerletterWithUser.offerLetter.reportingToUserIDs,
        [Validators.required]
      ),
      validUntilDate: new UntypedFormControl(
        offerletterWithUser.offerLetter.validUntilDate,
        [Validators.required]
      ),
      typePosition: new UntypedFormControl(
        offerletterWithUser.offerLetter.typePosition
          ? IsValidTyePosition(offerletterWithUser.offerLetter.typePosition)
            ? offerletterWithUser.offerLetter.typePosition
            : "Other"
          : "",
        [Validators.required, Validators.maxLength(255)]
      ),
      typePositionOther: new UntypedFormControl(
        offerletterWithUser.offerLetter.typePosition,
        [Validators.maxLength(255)]
      ),
      serviceRegion: new UntypedFormControl(
        offerletterWithUser.offerLetter.serviceRegion,
        [Validators.required, Validators.maxLength(255)]
      ),
      requiredBilledHours: new UntypedFormControl(
        offerletterWithUser.offerLetter.requiredBilledHours,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),
      salaryPayRate: new UntypedFormControl(
        offerletterWithUser.offerLetter.salaryPayRate,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),
      studentLoanRepayment: new UntypedFormControl(
        offerletterWithUser.offerLetter.studentLoanRepayment,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),
      cellphoneStipend: new UntypedFormControl(
        offerletterWithUser.offerLetter.cellphoneStipend,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),
      gasCard: new UntypedFormControl(offerletterWithUser.offerLetter.gasCard, [
        Validators.required,
        Validators.pattern("^([0-9]*[.])?[0-9]+$"),
      ]),
      professionalLiabilityInsurance: new UntypedFormControl(
        !offerletterWithUser.offerLetter.id
          ? 300
          : offerletterWithUser.offerLetter.professionalLiabilityInsurance
          ? offerletterWithUser.offerLetter.professionalLiabilityInsurance
          : 0,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),
      flexibleSchedule: new UntypedFormControl(
        offerletterWithUser.offerLetter.flexibleSchedule,
        [
          Validators.required,
          Validators.pattern("^[0-9]+$"),
          Validators.min(15),
        ]
      ),
      healthBenefitAnnualCost: new UntypedFormControl(
        offerletterWithUser.offerLetter.healthBenefitAnnualCost
          ? offerletterWithUser.offerLetter.healthBenefitAnnualCost
          : 0,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),
      relocationStipend: new UntypedFormControl(
        offerletterWithUser.offerLetter.relocationStipend,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),
      eletronicDevices: new UntypedFormControl(
        offerletterWithUser.offerLetter.eletronicDevices
          ? offerletterWithUser.offerLetter.eletronicDevices
          : 0,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),
      receivingSupervision: new UntypedFormControl(
        offerletterWithUser.offerLetter.receivingSupervision
          ? offerletterWithUser.offerLetter.receivingSupervision
          : 0,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),
      tuitionAssistanceBenefit: new UntypedFormControl(
        offerletterWithUser.offerLetter.tuitionAssistanceBenefit
          ? offerletterWithUser.offerLetter.tuitionAssistanceBenefit
          : 0,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),
      bonusByTypePosition: new UntypedFormControl(
        offerletterWithUser.offerLetter.bonusByTypePosition,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),
      plan401k: new UntypedFormControl(offerletterWithUser.offerLetter.plan401k, [
        Validators.required,
        Validators.pattern("^([0-9]*[.])?[0-9]+$"),
      ]),
      pto: new UntypedFormControl(offerletterWithUser.offerLetter.pto, [
        Validators.required,
        Validators.pattern("^([0-9]*[.])?[0-9]+$"),
      ]),
      holiday: new UntypedFormControl(offerletterWithUser.offerLetter.holiday, [
        Validators.required,
        Validators.pattern("^([0-9]*[.])?[0-9]+$"),
      ]),
      salaryPayRateAfterMonths: new UntypedFormControl(
        offerletterWithUser.offerLetter.salaryPayRateAfterMonths,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),
      otherBenefitName: new UntypedFormControl(
        offerletterWithUser.offerLetter.otherBenefitName,
        [Validators.required, Validators.maxLength(2000)]
      ),
      otherBenefitAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.otherBenefitAmount,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),
      salaryOrPayRate: new UntypedFormControl(
        offerletterWithUser.offerLetter.salaryOrPayRate
          ? offerletterWithUser.offerLetter.salaryOrPayRate
          : true,
        [Validators.required]
      ),
      regulatoryOversight: new UntypedFormControl(
        offerletterWithUser.offerLetter.regulatoryOversight
          ? offerletterWithUser.offerLetter.regulatoryOversight
          : 0,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),

      medClinic: new UntypedFormControl(
        offerletterWithUser.offerLetter.medClinic
          ? offerletterWithUser.offerLetter.medClinic
          : 0,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),
      mentalHealth: new UntypedFormControl(
        offerletterWithUser.offerLetter.mentalHealth
          ? offerletterWithUser.offerLetter.mentalHealth
          : 0,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),
      gym: new UntypedFormControl(
        offerletterWithUser.offerLetter.gym
          ? offerletterWithUser.offerLetter.gym
          : 0,
        [Validators.required, Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),

      studentLoanRepaymentCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.studentLoanRepayment > 0
      ),
      cellphoneStipendCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.cellphoneStipend > 0
      ),
      gasCardCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.gasCard > 0
      ),
      flexibleScheduleCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.flexibleSchedule > 0
      ),
      healthBenefitAnnualCostCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.healthBenefitAnnualCost > 0
      ),
      relocationStipendCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.relocationStipend > 0
      ),
      eletronicDevicesCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.eletronicDevices > 0
      ),
      receivingSupervisionCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.receivingSupervision > 0
      ),
      tuitionAssistanceBenefitCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.tuitionAssistanceBenefit > 0
      ),
      otherBenefitNameCheck: new UntypedFormControl(
        !!offerletterWithUser.offerLetter.otherBenefitName
      ),
      salaryPayRateAfterMonthsCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.salaryPayRateAfterMonths > 0
      ),
      regulatoryOversightCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.regulatoryOversight > 0
      ),
      medClinicCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.medClinic > 0
      ),
      mentalHealthCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.mentalHealth > 0
      ),
      gymCheck: new UntypedFormControl(offerletterWithUser.offerLetter.gym > 0),

      ptoPercentage: new UntypedFormControl(
        offerletterWithUser.offerLetter.id
          ? offerletterWithUser.offerLetter.ptoPercentage
          : 2
      ),
      monthsAfter: new UntypedFormControl(
        offerletterWithUser.offerLetter.id
          ? offerletterWithUser.offerLetter.monthsAfter
          : 12
      ),

      bonusByTypePositionCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.bonusByTypePosition > 0
      ),

      ptoCheck: new UntypedFormControl(offerletterWithUser.offerLetter.pto > 0),
      holidayCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.holiday > 0
      ),
      plan401kCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.plan401k > 0
      ),
      professionalLiabilityInsuranceCheck: new UntypedFormControl(
        offerletterWithUser.offerLetter.professionalLiabilityInsurance > 0
      ),

      requireTranscripts: new UntypedFormControl(
        offerletterWithUser.offerLetter.requireTranscripts
      ),
      requireDiploma: new UntypedFormControl(
        offerletterWithUser.offerLetter.requireDiploma
      ),
      requireLicenses: new UntypedFormControl(
        offerletterWithUser.offerLetter.requireLicenses
      ),

      orientationDate: new UntypedFormControl(
        offerletterWithUser.offerLetter.orientationDate
      ),
      positionStartDate: new UntypedFormControl(
        offerletterWithUser.offerLetter.positionStartDate
      ),
      jobTitleID: new UntypedFormControl(offerletterWithUser.offerLetter.jobTitleID, [
        Validators.required,
      ]),
      position: new UntypedFormControl(offerletterWithUser.offerLetter.position),

      studentLoanRepaymentHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.studentLoanRepaymentHideAmount
      ),
      cellphoneStipendHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.cellphoneStipendHideAmount
      ),
      gasCardHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.gasCardHideAmount
      ),
      professionalLiabilityInsuranceHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.professionalLiabilityInsuranceHideAmount
      ),
      healthBenefitAnnualCostHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.healthBenefitAnnualCostHideAmount
      ),
      relocationStipendHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.relocationStipendHideAmount
      ),
      eletronicDevicesHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.eletronicDevicesHideAmount
      ),
      receivingSupervisionHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.receivingSupervisionHideAmount
      ),
      tuitionAssistanceBenefitHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.tuitionAssistanceBenefitHideAmount
      ),
      bonusByTypePositionHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.bonusByTypePositionHideAmount
      ),
      plan401kHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.plan401kHideAmount
      ),
      ptoHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.ptoHideAmount
      ),
      holidayHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.holidayHideAmount
      ),
      otherBenefitHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.otherBenefitHideAmount
      ),
      regulatoryOversightHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.regulatoryOversightHideAmount
      ),
      medClinicHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.medClinicHideAmount
      ),
      mentalHealthHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.mentalHealthHideAmount
      ),
      gymHideAmount: new UntypedFormControl(
        offerletterWithUser.offerLetter.gymHideAmount
      ),

      studentLoanRepaymentRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.studentLoanRepaymentRemoveFromEstimated
      ),
      cellphoneStipendRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.cellphoneStipendRemoveFromEstimated
      ),
      gasCardRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.gasCardRemoveFromEstimated
      ),
      professionalLiabilityInsuranceRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.professionalLiabilityInsuranceRemoveFromEstimated
      ),
      healthBenefitAnnualCostRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.healthBenefitAnnualCostRemoveFromEstimated
      ),
      relocationStipendRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.relocationStipendRemoveFromEstimated
      ),
      eletronicDevicesRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.eletronicDevicesRemoveFromEstimated
      ),
      receivingSupervisionRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.receivingSupervisionRemoveFromEstimated
      ),
      tuitionAssistanceBenefitRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.tuitionAssistanceBenefitRemoveFromEstimated
      ),
      bonusByTypePositionRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.bonusByTypePositionRemoveFromEstimated
      ),
      plan401kRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.plan401kRemoveFromEstimated
      ),
      ptoRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.ptoRemoveFromEstimated
      ),
      holidayRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.holidayRemoveFromEstimated
      ),
      otherBenefitRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.otherBenefitRemoveFromEstimated
      ),
      regulatoryOversightRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.regulatoryOversightRemoveFromEstimated
      ),
      medClinicRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.medClinicRemoveFromEstimated
      ),
      mentalHealthRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.mentalHealthRemoveFromEstimated
      ),
      gymRemoveFromEstimated: new UntypedFormControl(
        offerletterWithUser.offerLetter.gymRemoveFromEstimated
      ),

      trainingRate: new UntypedFormControl(
        offerletterWithUser.offerLetter.trainingRate
          ? offerletterWithUser.offerLetter.trainingRate
          : 0,
        [Validators.pattern("^([0-9]*[.])?[0-9]+$")]
      ),
      trainingRateCheck: new UntypedFormControl(
        !offerletterWithUser.offerLetter.id ||
          !!offerletterWithUser.offerLetter.trainingRate
      ),

      hasProfitSharing: new UntypedFormControl(
        offerletterWithUser.offerLetter.hasProfitSharing
      ),
      hasIncentivePrograms: new UntypedFormControl(
        offerletterWithUser.offerLetter.hasIncentivePrograms
      ),
    }),
  });

  return form;
}

export function IsValidTyePosition(position) {
  return (
    [
      "Administrative",
      "Mental Health Clinician",
      "Behavior Clinician",
      "Behavior Technician",
      "Dually-Credentialed",
      "Psychologist",
      "Director",
    ].indexOf(position) >= 0
  );
}
